import { HeadContent, Outlet, Scripts, createRootRoute } from '@tanstack/react-router'
import * as React from 'react'
import { DefaultCatchBoundary } from '@components/default-cache-boundary'
import { NotFound } from '@components/not-found'
import { seo } from '@lib/utils'

import '@styles/globals.css'
import 'highlight.js/styles/github-dark.css'
import { Providers } from '@/components/providers/providers'
import Footer from '@/components/layout/footer'
import NavBar from '@/components/layout/navbar'
import BackToTop from '@/components/back-to-top'

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        charSet: 'utf-8'
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1'
      },
      ...seo({
        title: 'Blog | ley0x',
        description: `ley0x's blog, where I write about programming, technology, linux, open source, and other things.`,
      })
    ],
    links: [
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
      { rel: 'shortcut icon', type: 'image/x-icon', href: '/favicon.ico' },
      { rel: 'apple-touch-icon', href: '/favicon.ico' }
    ]
  }),
  errorComponent: props => {
    return (
      <RootDocument>
        <DefaultCatchBoundary {...props} />
      </RootDocument>
    )
  },
  notFoundComponent: () => <NotFound />,
  component: RootComponent
})

function RootComponent() {
  return (
    <RootDocument>
      <NavBar />
      <Outlet />
      <BackToTop />
      <Footer />
    </RootDocument>
  )
}

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <html suppressHydrationWarning>
      <head>
        <HeadContent />
      </head>
      <body className="min-h-vh border-transparent border relative">
        <Providers>
          <div className="flex flex-col justify-between min-h-full">
            {children}
          </div>
        </Providers>
        <Scripts />
      </body>
    </html>
  )
}
